import React, { useState } from 'react';
import { Package, Truck, CheckCircle, XCircle, ChevronDown, ChevronUp, MapPin, CreditCard, Download, ExternalLink } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { mockOrders } from '../../utils/mockAccountData';
import { Link } from 'react-router-dom';
export function OrderHistorySection() {
  const [activeTab, setActiveTab] = useState('all');
  const [expandedOrder, setExpandedOrder] = useState<string | null>(null);
  const tabs = [{
    id: 'all',
    label: 'Todos'
  }, {
    id: 'in-transit',
    label: 'En Camino'
  }, {
    id: 'delivered',
    label: 'Entregados'
  }, {
    id: 'cancelled',
    label: 'Cancelados'
  }];
  const filteredOrders = mockOrders.filter(order => {
    if (activeTab === 'all') return true;
    return order.status === activeTab;
  });
  const toggleOrder = (id: string) => {
    setExpandedOrder(expandedOrder === id ? null : id);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'in-transit':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-249">
            <Truck className="w-3 h-3 mr-1.5" data-id="element-250" /> En camino
          </span>;
      case 'delivered':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-251">
            <CheckCircle className="w-3 h-3 mr-1.5" data-id="element-252" /> Entregado
          </span>;
      case 'cancelled':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-253">
            <XCircle className="w-3 h-3 mr-1.5" data-id="element-254" /> Cancelado
          </span>;
      default:
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-255">
            Procesando
          </span>;
    }
  };
  return <div className="space-y-6" data-id="element-256">
      <div data-id="element-257">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-258">
          Historial de Pedidos
        </h2>
        <p className="text-sm text-gray-500 mt-1" data-id="element-259">
          Consulta el estado y detalle de tus compras recientes.
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200" data-id="element-260">
        <nav className="-mb-px flex space-x-8 overflow-x-auto no-scrollbar" data-id="element-261">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === tab.id ? 'border-emerald-500 text-emerald-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-262">
              {tab.label}
            </button>)}
        </nav>
      </div>

      {/* Orders List */}
      <div className="space-y-4" data-id="element-263">
        {filteredOrders.length > 0 ? filteredOrders.map(order => <Card key={order.id} className={`overflow-hidden transition-all duration-200 ${expandedOrder === order.id ? 'ring-1 ring-emerald-500 shadow-md' : ''}`} data-id="element-264">
              {/* Order Summary Header */}
              <div className="p-6 cursor-pointer hover:bg-gray-50 transition-colors" onClick={() => toggleOrder(order.id)} data-id="element-265">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-266">
                  <div className="flex items-center gap-4" data-id="element-267">
                    <div className="p-3 bg-emerald-50 rounded-lg text-emerald-600" data-id="element-268">
                      <Package className="w-6 h-6" data-id="element-269" />
                    </div>
                    <div data-id="element-270">
                      <div className="flex items-center gap-3 mb-1" data-id="element-271">
                        <span className="font-bold text-gray-900" data-id="element-272">
                          #{order.id}
                        </span>
                        {getStatusBadge(order.status)}
                      </div>
                      <p className="text-sm text-gray-500" data-id="element-273">
                        {new Date(order.date).toLocaleDateString('es-ES', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}{' '}
                        • {order.itemsCount} artículos
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between md:justify-end gap-6" data-id="element-274">
                    <div className="text-right" data-id="element-275">
                      <p className="text-sm text-gray-500" data-id="element-276">Total</p>
                      <p className="font-bold text-gray-900 text-lg" data-id="element-277">
                        {order.total.toFixed(2)}€
                      </p>
                    </div>
                    <button className="text-gray-400 hover:text-emerald-600 transition-colors" data-id="element-278">
                      {expandedOrder === order.id ? <ChevronUp className="w-5 h-5" data-id="element-279" /> : <ChevronDown className="w-5 h-5" data-id="element-280" />}
                    </button>
                  </div>
                </div>
              </div>

              {/* Expanded Details */}
              {expandedOrder === order.id && <div className="border-t border-gray-100 bg-gray-50/50 p-6 animate-fadeIn" data-id="element-281">
                  <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-282">
                    <div data-id="element-283">
                      <h4 className="text-sm font-bold text-gray-900 mb-3 flex items-center" data-id="element-284">
                        <MapPin className="w-4 h-4 mr-2 text-gray-400" data-id="element-285" />
                        Dirección de Envío
                      </h4>
                      <div className="text-sm text-gray-600 leading-relaxed" data-id="element-286">
                        <p className="font-medium text-gray-900" data-id="element-287">
                          {order.shippingAddress.name}
                        </p>
                        <p data-id="element-288">{order.shippingAddress.street}</p>
                        <p data-id="element-289">
                          {order.shippingAddress.postalCode},{' '}
                          {order.shippingAddress.city}
                        </p>
                        <p data-id="element-290">{order.shippingAddress.country}</p>
                      </div>
                    </div>
                    <div data-id="element-291">
                      <h4 className="text-sm font-bold text-gray-900 mb-3 flex items-center" data-id="element-292">
                        <CreditCard className="w-4 h-4 mr-2 text-gray-400" data-id="element-293" />
                        Método de Pago
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-294">
                        {order.paymentMethod}
                      </p>
                    </div>
                    <div data-id="element-295">
                      <h4 className="text-sm font-bold text-gray-900 mb-3 flex items-center" data-id="element-296">
                        <Truck className="w-4 h-4 mr-2 text-gray-400" data-id="element-297" />
                        Seguimiento
                      </h4>
                      <p className="text-sm text-gray-600 mb-2" data-id="element-298">
                        Número: {order.trackingNumber}
                      </p>
                      <a href="#" className="text-sm text-emerald-600 hover:underline inline-flex items-center" data-id="element-299">
                        Seguir envío <ExternalLink className="w-3 h-3 ml-1" data-id="element-300" />
                      </a>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden mb-6" data-id="element-301">
                    {order.items.map((item, index) => <div key={index} className="flex items-center p-4 border-b border-gray-100 last:border-0" data-id="element-302">
                        <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0 border border-gray-100" data-id="element-303">
                          <img src={item.image} alt={item.name} className="w-full h-full object-cover mix-blend-multiply" data-id="element-304" />
                        </div>
                        <div className="ml-4 flex-1" data-id="element-305">
                          <h5 className="font-medium text-gray-900" data-id="element-306">
                            {item.name}
                          </h5>
                          <p className="text-sm text-gray-500" data-id="element-307">
                            Cantidad: {item.quantity}
                          </p>
                        </div>
                        <div className="text-right font-medium text-gray-900" data-id="element-308">
                          {item.price.toFixed(2)}€
                        </div>
                      </div>)}
                  </div>

                  <div className="flex justify-end gap-3" data-id="element-309">
                    <Button variant="outline" size="sm" data-id="element-310">
                      <Download className="w-4 h-4 mr-2" data-id="element-311" />
                      Descargar Factura
                    </Button>
                    <Button size="sm" data-id="element-312">Volver a pedir</Button>
                  </div>
                </div>}
            </Card>) : <div className="text-center py-16 bg-white rounded-2xl border border-dashed border-gray-200" data-id="element-313">
            <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-314">
              <Package className="w-8 h-8 text-gray-400" data-id="element-315" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-316">
              No hay pedidos en esta sección
            </h3>
            <p className="text-gray-500 mb-6" data-id="element-317">
              Parece que no tienes pedidos con este estado.
            </p>
            <Link to="/productos" data-id="element-318">
              <Button data-id="element-319">Explorar Productos</Button>
            </Link>
          </div>}
      </div>
    </div>;
}